import dayjs, { Dayjs } from "dayjs";
import { ApiResponse } from "./models";

const cacheMap = new Map<string, { expiry: Dayjs; response: unknown }>();

export function createReadthroughCache<TResponse extends ApiResponse>(
  key: string,
  expiry: number,
  caller: (...args: unknown[]) => Promise<TResponse>
): (...args: unknown[]) => Promise<TResponse | undefined> {
  return async (args) => {
    const cacheData = cacheMap.get(key);
    const now = dayjs();
    if (!cacheData || now.isAfter(cacheData.expiry)) {
      const response = await caller(args);
      if (response) {
        cacheMap.set(key, { expiry: now.add(expiry), response: response });
        return response;
      }
    }

    return <TResponse>cacheData.response;
  };
}
